import { Component, OnDestroy, OnInit, ViewChild, computed, signal } from '@angular/core';
import { AqaSearchResultsComponent } from '../../../ai-search/components/aqa-search-results/aqa-search-results.component';
import { Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';
import { AQASearchResult, AQASearchRequest } from '../../../ai-search/models';
import { AQAService } from '../../../ai-search/services/aqa.service';
import { AiSearchBarComponent } from '../../../ai-search/components/ai-search-bar/ai-search-bar.component';
import { AqaFiltersComponent } from '../../../ai-search/components/aqa-filters/aqa-filters.component';
import { createDefaultSearchRequest } from '../../../ai-search/aqa.utils';

@Component({
  selector: 'app-page-aqa-search',
  standalone: true,
  imports: [AqaSearchResultsComponent, AiSearchBarComponent, AqaFiltersComponent],
  templateUrl: './page-aqa-search.component.html',
  styleUrl: './page-aqa-search.component.scss'
})
export class PageAqaSearchComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('aqaLatestSearchResults') aqaLatestSearchResults!: AqaSearchResultsComponent;
  @ViewChild('aqaSearchResults') aqaSearchResults!: AqaSearchResultsComponent;
  //@ViewChild('searchBar') aqaSearchBar!: AiSearchBarComponent;

  searchTerm = signal<string>('');

  latestAqaResults = signal<AQASearchResult[]>([]);
  latestAqaLoading = signal<boolean>(false);
  latestHasSearched = signal<boolean>(false);
  latestCurrentPage = signal<number>(1);
  latestPageSize = signal<number>(10);
  latestTotalCount = signal<number>(0);



  aqaResults = signal<AQASearchResult[]>([]);
  aqaLoading = signal<boolean>(false);
  hasSearched = signal<boolean>(false);
  // Pagination
  currentPage = computed(() => this.searchRequest().page);
  pageSize = signal<number>(10);
  totalCount = signal<number>(0);

  showFilter = signal<boolean>(false);
  filterSelected = false;

  // Filter state
  activeFilters = signal<Partial<AQASearchRequest>>({});
  searchRequest = signal<AQASearchRequest>(createDefaultSearchRequest());

  constructor(private aqaSearchService: AQAService) { }

  ngOnInit() {
    this.executeAqaSearch(true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onPageChange(page: number): void {
    const filters = this.activeFilters();
    const request: AQASearchRequest = {
      ...this.searchRequest(),
      ...filters,
      page: page
    };

    this.searchRequest.set(request);
    this.executeAqaSearch(false, request);
  }

  onSearch(term: string): void {
    const filters = this.activeFilters();
    const request: AQASearchRequest = {
      ...this.searchRequest(),
      ...filters,
      query: term || '*',
      page: 1
    };

    this.searchRequest.set(request);
    //this.activeFilters.set({});

    this.executeAqaSearch(false, request);
  }

  toggleFilter() {
    this.showFilter.set(!this.showFilter());
  }

  onFiltersChange(filters: Partial<AQASearchRequest>): void {
    this.filterSelected = false;
    if (filters.dateFrom || filters.dateTo || filters.fromFilter || filters.hasAttachments || filters.attachmentTypes) {
      this.filterSelected = true;
    }

    this.activeFilters.set(filters);

    const request: AQASearchRequest = {
      ...this.searchRequest(),
      ...filters,
      page: 1
    };

    this.searchRequest.set(request);
    this.executeAqaSearch(false, request);
  }

  onClearFilters(): void {
    this.filterSelected = false;
    this.activeFilters.set({});
    const filters = this.activeFilters();
    var request: AQASearchRequest = {
      query: this.searchRequest().query || '*',
      page: 1,
      searchScope: 'all',
      pageSize: this.aqaSearchResults.pageSize(),
      sortBy: 'date',
      sortOrder: 'desc',
      includeFacets: true
    };

    this.searchRequest.set(request);
    this.executeAqaSearch(false, request);
  }

  private executeAqaSearch(latest: boolean = false, req: AQASearchRequest | null = null) {

    if (latest) {
      this.latestAqaLoading.set(true);


      req = {
        query: '*',
        page: 1,
        pageSize: 10,
        searchScope: 'all',
        sortBy: 'date',
        sortOrder: 'desc',
        includeFacets: false,
        quickSearch: true
      };
    }
    else {
      this.aqaLoading.set(true);

      if (req == null) {
        this.aqaLoading.set(false);
        return;
      }
    }


    this.aqaSearchService.search(req!)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.aqaSearchResults.loading.set(false))
      )
      .subscribe({
        next: (response) => {

          if (latest) {
            this.latestHasSearched.set(true);
            this.latestAqaLoading.set(false);
            this.latestTotalCount.set(response.totalCount);

            if (this.aqaLatestSearchResults) {
              this.latestAqaResults.set(response.results);
              this.aqaLatestSearchResults.selectedResult.set(null);
            }
          }
          else {
            this.hasSearched.set(true);
            this.aqaLoading.set(false);
            this.totalCount.set(response.totalCount);

            if (this.aqaSearchResults) {
              this.aqaResults.set(response.results);
              this.aqaSearchResults.selectedResult.set(null);
            }
          }



        },
        error: (err) => {
          this.aqaResults.set([]);
          this.aqaSearchResults.selectedResult.set(null);
          if (latest) {
            this.latestAqaLoading.set(false);
          }
          else {
            this.aqaLoading.set(false);
          }
        }
      });
  }
}
